const algoliasearch = require('algoliasearch/lite')
const instantsearch = require('instantsearch.js').default
/*
 * Import our config and widgets
 * Note: elementsTypes, elementsCategories, elementsTechnology are all
 * exported from ElementsSelectMenus.js
 */
import {
  siteConfigure,
  siteMenu,
  siteClearRefinements,
  siteCustomSortBy,
  siteInfiniteHits,
  siteSearchBox,
  siteAnalytics
} from '../widgets/algolia/site'

/*
 * Import shared helpers
 */
import { handleToggleVisibility } from '../helpers/search'

export default class AlgoliaSearch {
  constructor(el) {
    this.el = el;
    this.setVars();
    this.init();
  }

  setVars() {
    this.appId = window.agI;
    this.apiKey = window.agSk;
    this.index = window.agSi
    this.indexByDate = window.agSid
    this.env = window.env;
  }

  init() {
    this.addSearch();
  }
  addSearch() {
    // start client
    const analytics = this.env === "production"; // only push analytics in production
    const algoliaClient = algoliasearch(this.appId,this.apiKey);
    const module = this.el;


    const searchClient = {
      ...algoliaClient,
      search(requests) {
        if (requests.every(({ params }) => !params.query)) {
          return Promise.resolve({
            results: requests.map(() => ({
              hits: [],
              nbHits: 0,
              nbPages: 0,
              page: 0,
              processingTimeMS: 0,
            })),
          });
        }
        return algoliaClient.search(requests);
      },
    }

    // build search
    const search = instantsearch({
      indexName: this.index,
      /*
       * function provided by Algolia so we can manipulate
       * of DOM elements depending on the state of the search.
       * Be sure to return helper.search() after.
       */
      searchFunction(helper) {
        const hideIfNoResults = document.querySelectorAll('[data-hide-no-site-results]')
        const showIfNoResults = document.querySelectorAll('[data-show-no-site-results]')
        if(helper.state.query === '') {
          handleToggleVisibility(hideIfNoResults, 'hide')
          handleToggleVisibility(showIfNoResults, 'show')
          module.classList.remove('s-results-showing')
        } else {
          handleToggleVisibility(hideIfNoResults, 'show')
          handleToggleVisibility(showIfNoResults, 'hide')
          module.classList.add('s-results-showing')
        }
        helper.search()
      },
      analytics: analytics,
      searchClient: searchClient
    })

    /*
     * Add our widgets that are imported
     * from js/widgets/algolia/elements/index.js
     */
    search.addWidgets([
      siteConfigure,
      siteAnalytics,
      siteMenu,
      siteCustomSortBy,
      siteClearRefinements,
      siteInfiniteHits,
      siteSearchBox
    ]);
    search.start();
  }
}
